// import moment from 'moment-timezone';
import logisticsApi from '@/api/logistics';
// import { formatDate, groupBy } from '../../lib/helper';

const SET_LOGISTICS = 'SET_LOGISTICS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const CLEAR_LOGISTICS = 'CLEAR_LOGISTICS';
const RESET_LOGISTICS = 'RESET_LOGISTICS';
const EDIT_LOGISTICS = 'EDIT_LOGISTICS';
const DELETE_LOGISTIC = 'DELETE_LOGISTIC';
const APPEND_LOGISTIC = 'APPEND_LOGISTIC';
const APPEND_NEW_LOGISTIC = 'APPEND_NEW_LOGISTIC';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';

const state = {
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
};

const mutations = {
	[SET_LOGISTICS](state, logistics) {
		state.all = logistics;
	},
	[APPEND_LOGISTIC](state, logistics) {
		state.all = state.all.concat(logistics);
	},
	[APPEND_NEW_LOGISTIC](state, logistic) {
		const logistics = state.all;
		logistics.unshift(logistic);
		state.all = logistics;
	},
	[DELETE_LOGISTIC](state, index) {
		state.all.splice(index, 1);
	},
	[CLEAR_LOGISTICS](state) {
		state.all = [];
	},
	[RESET_LOGISTICS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[DELETE_LOGISTIC](state, index) {
		state.all.splice(index, 1);
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
	[EDIT_LOGISTICS](state, logistic) {
		const index = state.all.findIndex(curr => curr._id === logistic._id);
		if (index !== -1) {
			state.all[index] = logistic;
		}
	},
};

const actions = {
	// cutomers
	// eslint-disable-next-line
	getLogistics({ commit, getters }, params) {
		if (!getters.isFetching) {
			const defaultParams = {
				page: getters.page,
			};
			const fetchParams = Object.assign({}, defaultParams, params);
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const logistics = response.data;

				if (getters.all.length === 0) {
					commit(SET_LOGISTICS, logistics);
				} else if (logistics.length !== 0) {
					commit(APPEND_LOGISTIC, logistics);
				}

				if (logistics.length < params.limit) {
					commit(SET_IS_ALL, true);
				} else {
					commit(SET_IS_ALL, false);
				}

				commit(ADD_PAGE);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			logisticsApi.getLogistics(fetchParams, callback, errorCallback);
		}
	},
	delete({ commit }, index) {
		commit(DELETE_LOGISTIC, index);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	clearLogistics({ commit }) {
		commit(CLEAR_LOGISTICS);
	},
	resetLogistics({ commit }) {
		commit(RESET_LOGISTICS);
	},
	updateLogistic({ commit }, logistic) {
		commit(EDIT_LOGISTICS, logistic);
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
